import { z } from 'zod';
import {
  ApiPath,
  sekolahSchema,
  jabatanSchema,
  roleSchema,
  pegawaiListItemSchema,
  pegawaiDetailSchema,
  honorPegawaiSchema,
  type CreateSekolahRequest,
  type UpdateSekolahRequest,
  type CreateJabatanRequest,
  type UpdateJabatanRequest,
  type CreatePegawaiRequest,
  type UpdatePegawaiRequest,
  type CreateHonorPegawaiRequest,
  type UpdateHonorPegawaiRequest,
  type PegawaiListQuery,
} from '@app/shared';
import { apiGet, apiPost, apiPatch, apiDelete, apiList } from '../../lib/api';

export async function getRoles() {
  return apiGet(ApiPath.MASTER.ROLES, z.array(roleSchema));
}

export async function getSekolahList(params?: {
  page?: number;
  limit?: number;
  search?: string;
  status_aktif?: boolean;
  sort_by?: string;
  sort_dir?: 'asc' | 'desc';
}) {
  return apiList(ApiPath.MASTER.SEKOLAH, sekolahSchema, params);
}

export async function getSekolah(id: number) {
  return apiGet(`${ApiPath.MASTER.SEKOLAH}/${id}`, sekolahSchema);
}

export async function createSekolah(body: CreateSekolahRequest) {
  return apiPost(ApiPath.MASTER.SEKOLAH, body, sekolahSchema);
}

export async function updateSekolah(id: number, body: UpdateSekolahRequest) {
  return apiPatch(`${ApiPath.MASTER.SEKOLAH}/${id}`, body, sekolahSchema);
}

export async function deleteSekolah(id: number) {
  return apiDelete(`${ApiPath.MASTER.SEKOLAH}/${id}`);
}

export async function getJabatanList(params?: {
  page?: number;
  limit?: number;
  search?: string;
  status_aktif?: boolean;
  sort_by?: string;
  sort_dir?: 'asc' | 'desc';
}) {
  return apiList(ApiPath.MASTER.JABATAN, jabatanSchema, params);
}

export async function getJabatan(id: number) {
  return apiGet(`${ApiPath.MASTER.JABATAN}/${id}`, jabatanSchema);
}

export async function createJabatan(body: CreateJabatanRequest) {
  return apiPost(ApiPath.MASTER.JABATAN, body, jabatanSchema);
}

export async function updateJabatan(id: number, body: UpdateJabatanRequest) {
  return apiPatch(`${ApiPath.MASTER.JABATAN}/${id}`, body, jabatanSchema);
}

export async function deleteJabatan(id: number) {
  return apiDelete(`${ApiPath.MASTER.JABATAN}/${id}`);
}

export async function getPegawaiList(params?: Partial<PegawaiListQuery>) {
  return apiList(ApiPath.MASTER.PEGAWAI, pegawaiListItemSchema, params);
}

export async function getPegawai(id: number) {
  return apiGet(`${ApiPath.MASTER.PEGAWAI}/${id}`, pegawaiDetailSchema);
}

export async function createPegawai(body: CreatePegawaiRequest) {
  return apiPost(ApiPath.MASTER.PEGAWAI, body, pegawaiDetailSchema);
}

export async function updatePegawai(id: number, body: UpdatePegawaiRequest) {
  return apiPatch(`${ApiPath.MASTER.PEGAWAI}/${id}`, body, pegawaiDetailSchema);
}

export async function deletePegawai(id: number) {
  return apiDelete(`${ApiPath.MASTER.PEGAWAI}/${id}`);
}

export async function getHonorPegawaiList(params?: {
  page?: number;
  limit?: number;
  search?: string;
  pegawai_id?: number;
}) {
  return apiList(ApiPath.MASTER.HONOR_PEGAWAI, honorPegawaiSchema, params);
}

export async function getHonorPegawaiByPegawai(pegawaiId: number) {
  const result = await getHonorPegawaiList({ pegawai_id: pegawaiId, limit: 1 });
  return result.rows[0] ?? null;
}

export async function createHonorPegawai(body: CreateHonorPegawaiRequest) {
  return apiPost(ApiPath.MASTER.HONOR_PEGAWAI, body, honorPegawaiSchema);
}

export async function updateHonorPegawai(id: number, body: UpdateHonorPegawaiRequest) {
  return apiPatch(`${ApiPath.MASTER.HONOR_PEGAWAI}/${id}`, body, honorPegawaiSchema);
}

export async function deleteHonorPegawai(id: number) {
  return apiDelete(`${ApiPath.MASTER.HONOR_PEGAWAI}/${id}`);
}
